import { connect } from 'react-redux';
import ExtrasPopover from './extrasPopover';

const mapStateToProps = (state) => {
  const {
    extras: {
      data: extras = [],
    },
    pdfContent: {
      identification: { pii },
    },
    metadata: { adobeContentType },
  } = state;

  return {
    extras,
    pii,
    adobeContentType,
  };
};

export default connect(mapStateToProps)(ExtrasPopover);
